/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeUserSessionConsentSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RevokeUserSessionConsentSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RevokeUserSessionConsentSecurity = {
  option1?: RevokeUserSessionConsentSecurityOption1 | undefined;
  option2?: RevokeUserSessionConsentSecurityOption2 | undefined;
};

export type RevokeUserSessionConsentRequest = {
  /**
   * The user_session_consent id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type RevokeUserSessionConsentSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RevokeUserSessionConsentSecurityOption1$outboundSchema:
  z.ZodMiniType<
    RevokeUserSessionConsentSecurityOption1$Outbound,
    RevokeUserSessionConsentSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function revokeUserSessionConsentSecurityOption1ToJSON(
  revokeUserSessionConsentSecurityOption1:
    RevokeUserSessionConsentSecurityOption1,
): string {
  return JSON.stringify(
    RevokeUserSessionConsentSecurityOption1$outboundSchema.parse(
      revokeUserSessionConsentSecurityOption1,
    ),
  );
}

/** @internal */
export type RevokeUserSessionConsentSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RevokeUserSessionConsentSecurityOption2$outboundSchema:
  z.ZodMiniType<
    RevokeUserSessionConsentSecurityOption2$Outbound,
    RevokeUserSessionConsentSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function revokeUserSessionConsentSecurityOption2ToJSON(
  revokeUserSessionConsentSecurityOption2:
    RevokeUserSessionConsentSecurityOption2,
): string {
  return JSON.stringify(
    RevokeUserSessionConsentSecurityOption2$outboundSchema.parse(
      revokeUserSessionConsentSecurityOption2,
    ),
  );
}

/** @internal */
export type RevokeUserSessionConsentSecurity$Outbound = {
  Option1?: RevokeUserSessionConsentSecurityOption1$Outbound | undefined;
  Option2?: RevokeUserSessionConsentSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RevokeUserSessionConsentSecurity$outboundSchema: z.ZodMiniType<
  RevokeUserSessionConsentSecurity$Outbound,
  RevokeUserSessionConsentSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RevokeUserSessionConsentSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RevokeUserSessionConsentSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function revokeUserSessionConsentSecurityToJSON(
  revokeUserSessionConsentSecurity: RevokeUserSessionConsentSecurity,
): string {
  return JSON.stringify(
    RevokeUserSessionConsentSecurity$outboundSchema.parse(
      revokeUserSessionConsentSecurity,
    ),
  );
}

/** @internal */
export type RevokeUserSessionConsentRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const RevokeUserSessionConsentRequest$outboundSchema: z.ZodMiniType<
  RevokeUserSessionConsentRequest$Outbound,
  RevokeUserSessionConsentRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function revokeUserSessionConsentRequestToJSON(
  revokeUserSessionConsentRequest: RevokeUserSessionConsentRequest,
): string {
  return JSON.stringify(
    RevokeUserSessionConsentRequest$outboundSchema.parse(
      revokeUserSessionConsentRequest,
    ),
  );
}
